export const getTaskTimeliness = (task) => {
  if (task.status === "Missed") return "late";
  if (!task.scheduledDateKey || !task.completedDate) return null;
  const completed = new Date(task.completedDate);
  if (Number.isNaN(completed.getTime())) return null;
  const completedKey = `${completed.getFullYear()}-${String(completed.getMonth() + 1).padStart(2, "0")}-${String(completed.getDate()).padStart(2, "0")}`;
  return completedKey <= task.scheduledDateKey ? "onTime" : "late";
};

export const filterClosedTasks = (tasks, filters) => tasks.filter((task) =>
  (!filters.status || task.status === filters.status) &&
  (!filters.machine || (task.machineIds || []).includes(filters.machine)) &&
  (!filters.customer || (task.customers || [task.customer]).includes(filters.customer)) &&
  (!filters.category || (task.taskCategories || []).includes(filters.category)) &&
  (!filters.route || task.route === filters.route) &&
  (!filters.executive || task.assignedToId === filters.executive) &&
  (!filters.timeliness || getTaskTimeliness(task) === filters.timeliness)
);
